import React from 'react';
import Modal from './Modal';
import './LogDownloadFormatModal.css';

/**
 * Modal to choose app-log download format: post-processed (chronologically
 * interleaved) or the raw uploaded file.
 * Props: isOpen, onClose, onSelectFormat('sorted' | 'raw'), disabled (e.g. while resolving/downloading)
 */
const LogDownloadFormatModal = ({ isOpen, onClose, onSelectFormat, disabled = false }) => {
  const handleSelect = (format) => {
    if (disabled) return;
    onSelectFormat(format);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Download log" className="log-download-format-modal">
      <div className="log-download-format-options">
        <button
          type="button"
          className="log-download-format-option"
          onClick={() => handleSelect('sorted')}
          disabled={disabled}
        >
          <span className="log-download-format-option-title">Download with post-processing</span>
          <span className="log-download-format-option-subtitle">
            Interleaves app-side and system-level log blocks into one chronological file.
          </span>
        </button>
        <button
          type="button"
          className="log-download-format-option"
          onClick={() => handleSelect('raw')}
          disabled={disabled}
        >
          <span className="log-download-format-option-title">Download raw uploaded log</span>
          <span className="log-download-format-option-subtitle">
            The file exactly as uploaded — app-side and system-level logs as separate, unmerged blocks.
          </span>
        </button>
      </div>
    </Modal>
  );
};

export default LogDownloadFormatModal;
